import { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import { combineUserName } from '@helpers/combineUserName';
import UserAvatarLetters from '@helpers/userAvatarLetters';
import { MediaViewerOutletContextState } from '@layouts/types';

export default function useUserPicture() {
  const { user } = useAuth();
  const { commentsList } = useOutletContext<MediaViewerOutletContextState>();

  const setMyPicture = useCallback(() => {
    if (!user) return { name: '', userId: '', email: '' };
    const { id, email } = user;
    const alt = UserAvatarLetters(combineUserName(user));
    return { name: alt, email, userId: id };
  }, [user]);

  const getUserPicture = useCallback(
    (commentId: string) => {
      const comment = commentsList.find((it) => it.id === commentId);
      if (!comment?.user) return { name: '', email: '', userId: '' };
      const { email, id } = comment.user;
      const alt = UserAvatarLetters(combineUserName(comment.user));
      return { name: alt, email, userId: id };
    },
    [commentsList]
  );

  return { setMyPicture, getUserPicture };
}
